import { render, staticRenderFns } from "./EMDeleteButton.vue?vue&type=template&id=00b1a9b5&"
import script from "./EMDeleteButton.vue?vue&type=script&lang=js&"
export * from "./EMDeleteButton.vue?vue&type=script&lang=js&"
import style0 from "./EMDeleteButton.vue?vue&type=style&index=0&id=00b1a9b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
